var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"h4 m-t-0 m-b-2",attrs:{"selenium":"portfolio-label"}},[_vm._v("\n    My Past Projects for "),_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.occupation))])]),(_vm.photos.length)?_c('gallery',{attrs:{"files":_vm.photos}}):_c('div',[_vm._v("No Photos")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }